// extracted by mini-css-extract-plugin
module.exports = {"Statistics":"Statistic_Statistics__1fH2_","Bar":"Statistic_Bar__3y5Te","Line":"Statistic_Line__qEAyF","Doughnut":"Statistic_Doughnut__IrSVE","head":"Statistic_head___AMfj"};